export default __webpack_public_path__ + "f23fa332bcac4e38aabeda5a5e51cd71.png";